module.exports = __webpack_public_path__ + "img/u652.e8cdd2bb.jpg";